import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actions from './actions';
import { useActions } from 'hooks/useActions';
import ConfirmModal from 'components/Modals/confirmModal';

export default function CommentArchiveModal({ comment, closeModal }) {
  const { archiveCommentSubmitting, archiveCommentSuccess, archiveCommentError } = useSelector(
    (state) => state.commentsReducer
  );
  const { archiveComment } = useActions(actions);

  useEffect(() => {
    if (archiveCommentSuccess) {
      closeModal();
    }
  }, [archiveCommentSuccess, closeModal]);

  useEffect(() => {
    if (archiveCommentError) {
      toast.error(archiveCommentError);
    }
  }, [archiveCommentError]);

  return (
    <ConfirmModal
      title="Archive Comment"
      text="Are you certain you want to archive the comment?"
      onCancel={closeModal}
      onConfirm={() => archiveComment(comment._id)}
      loading={archiveCommentSubmitting}
    />
  );
}
